import Api from 'libs/api/index';
import axios from 'axios';
import AuthService from 'services/Auth';

class VacancyApplicationsApi extends Api {
  constructor() {
    super('cv/vacancy_applications/');
  }

  getExcel(params) {
    const apiUrl = process.env.REACT_APP_API_URL;
    return axios({
      url: `${apiUrl}/cv/vacancy_applications.xlsx`,
      method: 'get',
      data: params.data,
      params: params.params,
      responseType: 'blob', // important
      headers: {
        'Content-Type': 'application/json',
        ...(params?.headers || {}),
        'auth-token': AuthService.getToken(),
      },
    });
  }

  getPDF(id, params, type) {
    const apiUrl = process.env.REACT_APP_API_URL;
    return axios({
      url: `${apiUrl}/cv/vacancy_applications/${id}/${type}`,
      method: 'get',
      data: {},
      params: params,
      responseType: 'blob', // important
      headers: {
        'Content-Type': 'application/json',
        'auth-token': AuthService.getToken(),
      },
    });
  }
}

export default VacancyApplicationsApi;
